export default "__VITE_ASSET__b6057ab4__"